export enum EPopupAttachmentType {
  VIDEO = 'VIDEO',
  IMAGE = 'IMAGE',
}
